import { shippingBacklog } from './shipping-backlog-de.i18n';

export const de = {
  shippingBacklog,
};